export const RENDER_ORDER = ['background', 'head', 'eyes', 'mouth', 'body', 'accessory', 'flair'];

export const traitCollections = [
  {
    id: 'default',
    name: 'Default',
    stepsData: [
      {
        num: 1,
        stepName: RENDER_ORDER[0],
        title: 'Background',
        options: [
            { id: 1, name: 'Aquamarine', imageName: 'aquamarine' },
            { id: 2, name: 'Armada', imageName: 'armada' },
            { id: 3, name: 'Aurora', imageName: 'aurora' },
            { id: 4, name: 'Bloom', imageName: 'bloom' },
            { id: 5, name: 'Blud', imageName: 'blud' },
            { id: 6, name: 'Bluebird', imageName: 'bluebird' },
            { id: 7, name: 'Bonbons', imageName: 'bonbons' },
            { id: 8, name: 'Brand', imageName: 'brand' },
            { id: 9, name: 'Candy', imageName: 'candy' },
            { id: 10, name: 'Cloud', imageName: 'cloud' },
            { id: 11, name: 'Creamsicle', imageName: 'creamsicle' },
            { id: 12, name: 'Dreamland', imageName: 'dreamland' },
            { id: 13, name: 'Fluorescent', imageName: 'fluorescent' },
            { id: 14, name: 'Forgotten', imageName: 'forgotten' },
            { id: 15, name: 'Fuego', imageName: 'fuego' },
            { id: 16, name: 'Grape', imageName: 'grape' },
            { id: 17, name: 'Gunmetal', imageName: 'gunmetal' },
            { id: 18, name: 'Hazard', imageName: 'hazard' },
            { id: 19, name: 'Hazy', imageName: 'hazy' },
            { id: 20, name: 'Heatwave', imageName: 'heatwave' },
            { id: 21, name: 'Lavender', imageName: 'lavender' },
            { id: 22, name: 'Light', imageName: 'light' },
            { id: 23, name: 'Midnight', imageName: 'midnight' },
            { id: 24, name: 'Minty', imageName: 'minty' },
            { id: 25, name: 'Old Red', imageName: 'old-red' },
            { id: 26, name: 'Overcast', imageName: 'overcast' },
            { id: 27, name: 'Peach', imageName: 'peach' },
            { id: 28, name: 'Pepeland', imageName: 'pepeland' },
            { id: 29, name: 'Perpol', imageName: 'perpol' },
            { id: 30, name: 'Poise', imageName: 'poise' },
            { id: 31, name: 'Rosé', imageName: 'rose' },
            { id: 32, name: 'Sky', imageName: 'sky' },
            { id: 33, name: 'Skyward', imageName: 'skyward' },
            { id: 34, name: 'Snowfall', imageName: 'snowfall' },
            { id: 35, name: 'Stripes', imageName: 'stripes' },
            { id: 36, name: 'Sunburst', imageName: 'sunburst' },
            { id: 37, name: 'Sunshine', imageName: 'sunshine' },
            { id: 38, name: 'Sunwaves', imageName: 'sunwaves' },
            { id: 39, name: 'Tang', imageName: 'tang' },
            { id: 40, name: 'Wanted', imageName: 'wanted' },
        ],
      },
      {
        num: 2,
        stepName: RENDER_ORDER[1],
        title: 'Head',
        options: [
            { id: 1, name: 'None', imageName: 'null' },
            { id: 2, name: 'Apollo - Bluu', imageName: 'apollo-bluu' },
            { id: 3, name: 'Apollo - Cloudstuff', imageName: 'apollo-cloudstuff' },
            { id: 4, name: 'Apollo - Fuego', imageName: 'apollo-fuego' },
            { id: 5, name: 'Apollo - Greycoat', imageName: 'apollo-greycoat' },
            { id: 6, name: 'Apollo - Lavender', imageName: 'apollo-lavender' },
            { id: 7, name: 'Apollo - Minty', imageName: 'apollo-minty' },
            { id: 8, name: 'Apollo - Perpol', imageName: 'apollo-perpol' },
            { id: 9, name: 'Apollo - Pnk', imageName: 'apollo-pnk' },
            { id: 10, name: 'Apollo - Storm', imageName: 'apollo-storm' },
            { id: 11, name: 'Apollo - Swamp', imageName: 'apollo-swamp' },
            { id: 12, name: 'Apollo - Yello', imageName: 'apollo-yello' },
            { id: 13, name: 'Burnie - Bluu', imageName: 'burnie-bluu' },
            { id: 14, name: 'Burnie - Cloudstuff', imageName: 'burnie-cloudstuff' },
            { id: 15, name: 'Burnie - Fuego', imageName: 'burnie-fuego' },
            { id: 16, name: 'Burnie - Greycoat', imageName: 'burnie-greycoat' },
            { id: 17, name: 'Burnie - Lavender', imageName: 'burnie-lavender' },
            { id: 18, name: 'Burnie - Minty', imageName: 'burnie-minty' },
            { id: 19, name: 'Burnie - Perpol', imageName: 'burnie-perpol' },
            { id: 20, name: 'Burnie - Pnk', imageName: 'burnie-pnk' },
            { id: 21, name: 'Burnie - Storm', imageName: 'burnie-storm' },
            { id: 22, name: 'Burnie - Swamp', imageName: 'burnie-swamp' },
            { id: 23, name: 'Burnie - Yello', imageName: 'burnie-yello' },
            { id: 23, name: 'Cloudy - Bluu', imageName: 'cloudy-bluu' },
            { id: 24, name: 'Cloudy - Cloudstuff', imageName: 'cloudy-cloudstuff' },
            { id: 25, name: 'Cloudy - Fuego', imageName: 'cloudy-fuego' },
            { id: 26, name: 'Cloudy - Ghzt', imageName: 'cloudy-ghzt' },
            { id: 27, name: 'Cloudy - Greycoat', imageName: 'cloudy-greycoat' },
            { id: 28, name: 'Cloudy - Lavender', imageName: 'cloudy-lavender' },
            { id: 29, name: 'Cloudy - Minty', imageName: 'cloudy-minty' },
            { id: 30, name: 'Cloudy - Oni', imageName: 'cloudy-oni' },
            { id: 31, name: 'Cloudy - Perpol - Skully', imageName: 'cloudy-perpol-skully' },
            { id: 32, name: 'Cloudy - Perpol', imageName: 'cloudy-perpol' },
            { id: 33, name: 'Cloudy - Pnk', imageName: 'cloudy-pnk' },
            { id: 34, name: 'Cloudy - Skully', imageName: 'cloudy-skully' },
            { id: 35, name: 'Cloudy - Storm', imageName: 'cloudy-storm' },
            { id: 36, name: 'Cloudy - Swamp', imageName: 'cloudy-swamp' },
            { id: 37, name: 'Cloudy - Yello', imageName: 'cloudy-yello' },
            { id: 38, name: 'Lucky - Cloudstuff', imageName: 'lucky-cloudstuff' },
            { id: 39, name: 'Lucky - Fuego', imageName: 'lucky-fuego' },
            { id: 40, name: 'Lucky - Greycoat', imageName: 'lucky-greycoat' },
            { id: 41, name: 'Lucky - Pnk', imageName: 'lucky-pnk' },
            { id: 42, name: 'Lucky - Swamp', imageName: 'lucky-swamp' },
            { id: 43, name: 'Lucky - Yello', imageName: 'lucky-yello' },
            { id: 44, name: 'Luna - Bluu', imageName: 'luna-bluu' },
            { id: 45, name: 'Luna - Cloudstuff', imageName: 'luna-cloudstuff' },
            { id: 46, name: 'Luna - Fuego', imageName: 'luna-fuego' },
            { id: 47, name: 'Luna - Greycoat', imageName: 'luna-greycoat' },
            { id: 48, name: 'Luna - Lavender', imageName: 'luna-lavender' },
            { id: 49, name: 'Luna - Minty', imageName: 'luna-minty' },
            { id: 50, name: 'Luna - Perpol', imageName: 'luna-perpol' },
            { id: 51, name: 'Luna - Pnk', imageName: 'luna-pnk' },
            { id: 52, name: 'Luna - Storm', imageName: 'luna-storm' },
            { id: 53, name: 'Luna - Swamp', imageName: 'luna-swamp' },
            { id: 54, name: 'Luna - Yello', imageName: 'luna-yello' },
        ],
      },
      {
        num: 3,
        stepName: RENDER_ORDER[2],
        title: 'Eyes',
        options: [
            { id: 1, name: 'None', imageName: 'null' },
            { id: 2, name: 'Adoration', imageName: 'adoration' },
            { id: 3, name: 'Anger', imageName: 'anger' },
            { id: 4, name: 'Anime', imageName: 'anime' },
            { id: 5, name: 'Bandit - Blue', imageName: 'bandit-blue' },
            { id: 6, name: 'Bandit - OJ', imageName: 'bandit-oj' },
            { id: 7, name: 'Bandit - Purple', imageName: 'bandit-purple' },
            { id: 8, name: 'Bandit - Red', imageName: 'bandit-red' },
            { id: 9, name: 'Bob', imageName: 'bob' },
            { id: 10, name: 'Charm', imageName: 'charm' },
            { id: 11, name: 'Cyclops', imageName: 'cyclops' },
            { id: 12, name: 'Dazed', imageName: 'dazed' },
            { id: 13, name: 'Dexter', imageName: 'dexter' },
            { id: 14, name: 'Dummy', imageName: 'dummy' },
            { id: 15, name: 'Evol', imageName: 'evol' },
            { id: 16, name: 'Finn', imageName: 'finn' },
            { id: 17, name: 'Glare', imageName: 'glare' },
            { id: 18, name: 'Goggles', imageName: 'goggles' },
            { id: 19, name: 'Goh', imageName: 'goh' },
            { id: 20, name: 'Kirby', imageName: 'kirby' },
            { id: 21, name: 'Laze', imageName: 'laze' },
            { id: 22, name: 'Loony', imageName: 'loony' },
            { id: 23, name: 'Martian', imageName: 'martian' },
            { id: 24, name: 'Monocle', imageName: 'monocle' },
            { id: 25, name: 'Morish', imageName: 'morish' },
            { id: 26, name: 'Nerd', imageName: 'nerd' },
            { id: 27, name: 'Patch', imageName: 'patch' },
            { id: 28, name: 'Pepe', imageName: 'pepe' },
            { id: 29, name: 'Regular', imageName: 'regular' },
            { id: 30, name: 'Sleep', imageName: 'sleep' },
            { id: 31, name: 'Spidey', imageName: 'spidey' },
            { id: 32, name: 'Sunnies - Lenny', imageName: 'sunnies-lenny' },
            { id: 33, name: 'Sunnies - Shady', imageName: 'sunnies-shady' },
            { id: 34, name: 'Sunnies - Tripple', imageName: 'sunnies-tripple' },
            { id: 35, name: 'Sus', imageName: 'sus' },
            { id: 36, name: 'Tense', imageName: 'tense' },
            { id: 37, name: 'Toaster', imageName: 'toaster' },
            { id: 38, name: 'Vizor - Blue', imageName: 'vizor-blue' },
            { id: 39, name: 'Vizor - OJ', imageName: 'vizor-oj' },
            { id: 40, name: 'Woop', imageName: 'woop' },
        ],
      },
      {
        num: 4,
        stepName: RENDER_ORDER[3],
        title: 'Mouth',
        options: [
          { id: 1, name: 'None', imageName: 'null' },
          { id: 2, name: 'Zip - Gold', imageName: 'zip-gold' },
          { id: 3, name: 'Big - Smile', imageName: 'big-smile' },
          { id: 4, name: 'Chill', imageName: 'chill' },
          { id: 5, name: 'Chu', imageName: 'chu' },
          { id: 6, name: 'Cool', imageName: 'cool' },
          { id: 7, name: 'Cute', imageName: 'cute' },
          { id: 8, name: 'Drool - Blue', imageName: 'drool-blue' },
          { id: 9, name: 'Drool - Green', imageName: 'drool-green' },
          { id: 10, name: 'Drool - Purple', imageName: 'drool-purple' },
          { id: 11, name: 'Forced', imageName: 'forced' },
          { id: 12, name: 'Frank', imageName: 'frank' },
          { id: 13, name: 'Frown', imageName: 'frown' },
          { id: 14, name: 'Gentleman', imageName: 'gentleman' },
          { id: 15, name: 'Gum', imageName: 'gum' },
          { id: 16, name: 'Lucy', imageName: 'lucy' },
          { id: 17, name: 'Mob', imageName: 'mob' },
          { id: 18, name: 'Pepe', imageName: 'pepe' },
          { id: 19, name: 'Pout', imageName: 'pout' },
          { id: 20, name: 'Scream', imageName: 'scream' },
          { id: 21, name: 'Small - Smile', imageName: 'small-smile' },
          { id: 22, name: 'Square', imageName: 'square' },
          { id: 23, name: 'Stash', imageName: 'stash' },
          { id: 24, name: 'Stern', imageName: 'stern' },
          { id: 25, name: 'Toof', imageName: 'toof' },
          { id: 26, name: 'Vamp', imageName: 'vamp' },
          { id: 27, name: 'Vom - Rainbow', imageName: 'vom-rainbow' },
          { id: 28, name: 'Zip - Brand', imageName: 'zip-brand' },
          { id: 29, name: 'Zip - Cold', imageName: 'zip-cold' },
        ],
      },
      {
        num: 5,
        stepName: RENDER_ORDER[4],
        title: 'Body',
        options: [
            { id: 1, name: 'Black - Suit', imageName: 'black-suit' },
            { id: 2, name: 'Blue - Suit', imageName: 'blue-suit' },
            { id: 3, name: 'Bluu Tee - Bluu', imageName: 'bluu-tee-bluu' },
            { id: 4, name: 'Bluu Tee - Cloudstuff', imageName: 'bluu-tee-cloudstuff' },
            { id: 5, name: 'Broke', imageName: 'broke' },
            { id: 6, name: 'Bunneh - Suit - Blue', imageName: 'bunneh-suit-blue' },
            { id: 7, name: 'Bunneh - Suit - Pnk', imageName: 'bunneh-suit-pnk' },
            { id: 8, name: 'Cold - Grey', imageName: 'cold-grey' },
            { id: 9, name: 'Cold - Red', imageName: 'cold-red' },
            { id: 10, name: 'Dadbod - Cloudstuff', imageName: 'dadbod-cloudstuff' },
            { id: 11, name: 'Dadbod - Luckystar', imageName: 'dadbod-luckystar' },
            { id: 12, name: 'Fuego Tee - Cloudstuff', imageName: 'fuego-tee-cloudstuff' },
            { id: 13, name: 'Fuego Tee - Fuego', imageName: 'fuego-tee-fuego' },
            { id: 14, name: 'Fwog - Suit', imageName: 'fwog-suit' },
            { id: 15, name: 'Ghzt', imageName: 'ghzt' },
            { id: 16, name: 'Gold Tee - Cloudstuff', imageName: 'gold-tee-cloudstuff' },
            { id: 17, name: 'Green Tee - Cloudstuff', imageName: 'green-tee-cloudstuff' },
            { id: 18, name: 'Grey Tee - Cloudstuff', imageName: 'grey-tee-cloudstuff' },
            { id: 19, name: 'Grey Tee - Greycoat', imageName: 'grey-tee-greycoat' },
            { id: 20, name: 'Hoodie', imageName: 'hoodie' },
            { id: 21, name: 'Lavender Tee - Cloudstuff', imageName: 'lavender-tee-cloudstuff' },
            { id: 22, name: 'Lavender Tee - Lavender', imageName: 'lavender-tee-lavender' },
            { id: 23, name: 'Minty Tee - Cloudstuff', imageName: 'minty-tee-cloudstuff' },
            { id: 24, name: 'Minty Tee - Minty', imageName: 'minty-tee-minty' },
            { id: 25, name: 'Nakie - Bluu', imageName: 'nakie-bluu' },
            { id: 26, name: 'Nakie - Cloudstuff', imageName: 'nakie-cloudstuff' },
            { id: 27, name: 'Nakie - Fuego', imageName: 'nakie-fuego' },
            { id: 28, name: 'Nakie - Greycoat', imageName: 'nakie-greycoat' },
            { id: 29, name: 'Nakie - Lavender', imageName: 'nakie-lavender' },
            { id: 30, name: 'Nakie - Minty', imageName: 'nakie-minty' },
            { id: 31, name: 'Nakie - Perpol', imageName: 'nakie-perpol' },
            { id: 32, name: 'Nakie - Pnk', imageName: 'nakie-pnk' },
            { id: 33, name: 'Nakie - Storm', imageName: 'nakie-storm' },
            { id: 34, name: 'Nakie - Swamp', imageName: 'nakie-swamp' },
            { id: 35, name: 'Nakie - Yello', imageName: 'nakie-yello' },
            { id: 36, name: 'Navy Tee - Cloudstuff', imageName: 'navy-tee-cloudstuff' },
            { id: 37, name: 'Office - Aqua', imageName: 'office-aqua' },
            { id: 38, name: 'Office - Red', imageName: 'office-red' },
            { id: 39, name: 'Perpol Tee - Cloudstuff', imageName: 'perpol-tee-cloudstuff' },
            { id: 40, name: 'Perpol Tee - Perpol', imageName: 'perpol-tee-perpol' },
            { id: 41, name: 'Pnk Tee - Cloudstuff', imageName: 'pnk-tee-cloudstuff' },
            { id: 42, name: 'Pnk Tee - Pnk', imageName: 'pnk-tee-pnk' },
            { id: 43, name: 'Puffer - Goldzip', imageName: 'puffer-goldzip' },
            { id: 44, name: 'Puffer - Mint', imageName: 'puffer-mint' },
            { id: 45, name: 'Puffer - Pink', imageName: 'puffer-pink' },
            { id: 46, name: 'Puffer - Purpzip', imageName: 'puffer-purpzip' },
            { id: 47, name: 'Puffer - Redzip', imageName: 'puffer-redzip' },
            { id: 48, name: 'Scarecrow', imageName: 'scarecrow' },
            { id: 49, name: 'Shirk - Suit - Blue', imageName: 'shirk-suit-blue' },
            { id: 50, name: 'Shirk - Suit - Grey', imageName: 'shirk-suit-grey' },
            { id: 51, name: 'Sky - Blue Tee - Cloudstuff', imageName: 'sky-blue-tee-cloudstuff' },
            { id: 52, name: 'Storm Tee - Cloudstuff', imageName: 'storm-tee-cloudstuff'},
            { id: 53, name: 'Storm Tee - Storm', imageName: 'storm-tee-storm'},
            { id: 54, name: 'Swamp Tee - Cloudstuff', imageName: 'swamp-tee-cloudstuff'},
            { id: 55, name: 'Swamp Tee - Swamp', imageName: 'swamp-tee-swamp'},
            { id: 56, name: 'Sweater - Navy', imageName: 'sweater-navy'},
            { id: 57, name: 'Sweater - Red', imageName: 'sweater-red'},
            { id: 58, name: 'Sweater - White', imageName: 'sweater-white'},
            { id: 59, name: 'White Tee - Cloudstuff', imageName: 'white-tee-cloudstuff'},
            { id: 60, name: 'Yello Tee - Yello', imageName: 'yello-tee-yello'},
        ],
      },
      {
        num: 6,
        stepName: RENDER_ORDER[5],
        title: 'Accessory',
        options: [
            { id: 1, name: 'None', imageName: 'null' },
            { id: 2, name: 'Ag', imageName: 'ag' },
            { id: 3, name: 'Au', imageName: 'au' },
            { id: 4, name: 'Bandana', imageName: 'bandana' },
            { id: 5, name: 'Beanie - Black', imageName: 'beanie-black' },
            { id: 6, name: 'Beanie - Pink', imageName: 'beanie-pink' },
            { id: 7, name: 'Bolt', imageName: 'bolt' },
            { id: 8, name: 'Braincage', imageName: 'braincage' },
            { id: 9, name: 'Bulba', imageName: 'bulba' },
            { id: 10, name: 'Bunn', imageName: 'bunn' },
            { id: 11, name: 'Bunneh - Blue', imageName: 'bunneh-blue' },
            { id: 12, name: 'Bunneh - Pink', imageName: 'bunneh-pink' },
            { id: 13, name: 'Chopper', imageName: 'chopper' },
            { id: 14, name: 'Clownie', imageName: 'clownie' },
            { id: 15, name: 'Cosmo', imageName: 'cosmo' },
            { id: 16, name: 'Deado', imageName: 'deado' },
            { id: 17, name: 'Dex', imageName: 'dex' },
            { id: 18, name: 'Finn', imageName: 'finn' },
            { id: 19, name: 'Fisherman', imageName: 'fisherman' },
            { id: 20, name: 'Fungi - Blue', imageName: 'fungi-blue' },
            { id: 21, name: 'Fungi - Green', imageName: 'fungi-green' },
            { id: 22, name: 'Fungi - Red', imageName: 'fungi-red' },
            { id: 23, name: 'Fwog', imageName: 'fwog' },
            { id: 24, name: 'Horns - Lavender', imageName: 'horns-lavender' },
            { id: 25, name: 'Horns - Red', imageName: 'horns-red' },
            { id: 26, name: 'Horns - Storm', imageName: 'horns-storm' },
            { id: 27, name: 'Horns - White', imageName: 'horns-white' },
            { id: 28, name: 'Illuminati', imageName: 'illuminati' },
            { id: 29, name: 'Jaws - Blue', imageName: 'jaws-blue' },
            { id: 30, name: 'Jaws - Grey', imageName: 'jaws-grey' },
            { id: 31, name: 'Json', imageName: 'json' },
            { id: 32, name: 'Karate - Black', imageName: 'karate-black' },
            { id: 33, name: 'Karate - Red', imageName: 'karate-red' },
            { id: 34, name: 'Ketchum', imageName: 'ketchum' },
            { id: 35, name: 'Luna Ring', imageName: 'luna-ring' },
            { id: 36, name: 'Mojo', imageName: 'mojo' },
            { id: 37, name: 'Octo', imageName: 'octo' },
            { id: 38, name: 'Party - Hat', imageName: 'party-hat' },
            { id: 39, name: 'Potara', imageName: 'potara' },
            { id: 40, name: 'Rick', imageName: 'rick' },
            { id: 41, name: 'Slick', imageName: 'slick' },
            { id: 42, name: 'Snapback', imageName: 'snapback' },
            { id: 43, name: 'Sprout', imageName: 'sprout' },
            { id: 44, name: 'Steve', imageName: 'steve' },
            { id: 45, name: 'Strand', imageName: 'strand' },
            { id: 46, name: 'Strawhat', imageName: 'strawhat' },
            { id: 47, name: 'Tough', imageName: 'tough' },
            { id: 48, name: 'Trucker', imageName: 'trucker' },
            { id: 49, name: 'Warrior', imageName: 'warrior' },
            { id: 50, name: 'Zard', imageName: 'zard' },
        ],
      },
      {
        num: 7,
        stepName: RENDER_ORDER[6],
        title: 'Flair',
        options: [
          { id: 1, name: 'None', imageName: 'null' },
          { id: 2, name: 'Bolt', imageName: 'bolt' },
          { id: 3, name: 'Cape - Dark', imageName: 'cape-dark' },
          { id: 4, name: 'Cape - Red', imageName: 'cape-red' },
          { id: 5, name: 'Cape - White', imageName: 'cape-white' },
          { id: 6, name: 'Cartoons - Badge', imageName: 'cartoons-badge' },
          { id: 7, name: 'Cannon - Gold', imageName: 'cannon-gold' },
          { id: 8, name: 'Cannon - White', imageName: 'cannon-white' },
          { id: 9, name: 'Cwoud', imageName: 'cwoud' },
          { id: 10, name: 'GM - Pocket', imageName: 'gm-pocket' },
          { id: 11, name: 'Happycloud', imageName: 'happycloud' },
          { id: 12, name: 'King', imageName: 'king' },
          { id: 13, name: 'Noot', imageName: 'noot' },
          { id: 14, name: 'Pocket - Cloud', imageName: 'pocket-cloud' },
          { id: 15, name: 'Pocket - Fwog', imageName: 'pocket-fwog' },
          { id: 16, name: 'Pocket - Hurt', imageName: 'pocket-hurt' },
          { id: 17, name: 'Skull - Chain', imageName: 'skull-chain' },
          { id: 18, name: 'Smiley - Chain', imageName: 'smiley-chain' },
          { id: 19, name: 'Weather', imageName: 'weather' },
        ],
      },
    ]
  }
];

